<router-outlet></router-outlet>

<app-loading-spinner></app-loading-spinner>
